import { replace } from 'react-router-dom';
import { fetchSignupStep } from '@/features/Signup/api/requests';

export const authLoader = async (): Promise<string | Response> => {
  const token = localStorage.getItem('token');

  if (token) {
    const response = await fetchSignupStep(token);

    if (response && response.step === null) {
      return replace('/cabinet', { status: 301 });
    }

    if (typeof response?.step === 'number') {
      return replace('/signup', { status: 301 });
    }

    return '';
  }
  return '';
};
